module.exports = __webpack_public_path__ + "img/mobileladdercontrol6.647952c6.png";